function anchorDropdown() {
  const main = document.querySelector('.site-anchor-jump');
  const toggleBtn = document.querySelector('.site-anchor-jump__toggle');
  const dropdown = document.getElementById('site-anchor-jump__dropdown');
  const closeBtn = document.querySelector('.site-anchor-jump__close');

  if (!main || !toggleBtn || !dropdown) return;

  const openClass = 'open';
  const scrolledClass = 'scrolled';

  const offsetTop = main.offsetTop;
  let lastScrollY = window.scrollY;

  const isOpen = () => dropdown.classList.contains(openClass);

  const openDropdown = () => {
    dropdown.classList.add(openClass);
    toggleBtn.setAttribute('aria-expanded', 'true');
    main.classList.add(scrolledClass);
  };

  const closeDropdown = () => {
    dropdown.classList.remove(openClass);
    toggleBtn.setAttribute('aria-expanded', 'false');
  };

  const removeAllState = () => {
    closeDropdown();
    main.classList.remove(scrolledClass);
  };

  const updateScrolledState = () => {
    const currentScrollY = window.scrollY;
    const scrolledPast = currentScrollY > offsetTop;
    const scrollingDown = currentScrollY > lastScrollY;
    const scrollingUp = currentScrollY < lastScrollY;

    if (currentScrollY === lastScrollY) return;

    if (scrolledPast) {
      main.classList.add(scrolledClass);
      if (isOpen() && scrollingDown) {
        closeDropdown();
      }
    }

    if (!scrolledPast && scrollingUp) {
      removeAllState();
    }

    lastScrollY = currentScrollY;
  };

  const toggleDropdown = () => {
    if (isOpen()) {
      closeDropdown();
    } else {
      openDropdown();
    }
  };

  toggleBtn.addEventListener('click', toggleDropdown);

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDropdown);
  }

  // ✅ Close dropdown when any internal anchor link is clicked
  dropdown.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      closeDropdown();
    });
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target) && !toggleBtn.contains(e.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDropdown();
    }
  });

  window.addEventListener('scroll', updateScrolledState);
  updateScrolledState();
}

window.anchorDropdown = anchorDropdown;